import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'player-play', 'PlayerPlay', [["path",{"d":"M7 4v16l13 -8l-13 -8"}]]);